module.exports = __webpack_public_path__ + "static/media/ic-desk.ce18a0cf.svg";